import { _search } from '../api/search';

export const search = (searchParams) =>
    new Promise(function (resolve, reject) {
        _search(searchParams)
            .then(data => resolve(data))
            .catch(error => reject(error));
    });